import React from 'react';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import RewardTypeList from './RewardsMasterList';
import BreadCrumb from '../../../Components/Common/BreadCrumb';

const RewardsMaster = () => {
  document.title = 'Rewards';
  return (
    <div className="page-content p-4">
      <BreadCrumb titleInActive={'Admin'} titleActive="Rewards" />
      <RewardTypeList />
    </div>
  );
};

export default RewardsMaster;
